import items from "../constants/featuredProduct.jsx";
import React from "react";
import Carousel from "react-material-ui-carousel";
import { Paper } from "@mui/material";
import IntroInfoCard from "./home/IntroSection.jsx";
import AimBanner from "./home/Aim.jsx";
import Banner1 from "./home/Banner1.jsx";
import StatsBanner from "./home/StatsBanner.jsx";
import CustomerBanner from "./home/Customers.jsx";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";

function FeaturedProducts(props) {
  return (
    <Carousel
      indicators={false}
      className="w-full bg-black"
      NextIcon={
        <ArrowForwardIos sx={{ fontSize: "4rem", marginRight: "5vw" }} />
      }
      PrevIcon={<ArrowBackIos sx={{ fontSize: "4rem", marginLeft: "5vw" }} />}
    >
      {items.map((item, i) => (
        <Item key={i} item={item} />
      ))}
    </Carousel>
  );
}

function Item(props) {
  return (
    <Paper
      className={`px-[5%] mx-auto max-h-[80vh] `}
      sx={{
        backgroundColor: "black",
        marginX: "auto",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <img
        src={props.item.image}
        alt={props.item.description}
        className="bg-black"
        style={{
          maxHeight: "80vh",
          objectFit: "contain",
          width: "100%",
        }}
      />
    </Paper>
  );
}

const HomePage = () => {
  return (
    <div className="mt-28">
      <FeaturedProducts />
      <IntroInfoCard />
      <AimBanner />
      <StatsBanner />
      <Banner1 />
      <CustomerBanner />
    </div>
  );
};
export default HomePage;
